export const isDevelopment =
  window.location.hostname === 'localhost' ||
  window.location.hostname === 'p6-qa.samsung.com'
